import { styled } from '@mui/material/styles';

import { PALETTE } from '../../../theme/palette';

export const DA_DIREKT_FONT = {
  href: 'https://www.da-direkt.de/-/media/Themes/DADirekt/Global/DADirektTheme/fonts/centrano2-medium-woff2.woff2',
  rel: 'preload',
  as: 'font',
  type: 'font/woff2',
};

const cardBackground = (product) =>
  ({
    dental: {
      backgroundColor: PALETTE.DA_DIREKT_LIGHT_ORANGE,
    },
    pet: {
      backgroundColor: PALETTE.DA_DIREKT_LIGHT_BLUE,
    },
    health: {
      backgroundColor: PALETTE.DA_DIREKT_LIGHT_GREEN,
    },
  })[`${product}`];

export const StyledDaDirektCrossSellingCard = styled('div')(({ theme, product }) => ({
  position: 'relative',
  display: 'flex',
  padding: theme.spacing('LARGE'),
  width: '100%',
  height: '13.75rem',

  ...(cardBackground(product) || {}),

  [theme.breakpoints.up('desktop')]: {
    padding: theme.spacing('1XL'),
    height: '18.75rem',
  },
}));

export const StyledDaDirektCrossSellingCardContent = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const StyledDaDirektCrossSellingCardTitle = styled('h1')(({ theme }) => ({
  margin: 0,
  padding: `${theme.spacing('SMALL')} 0 0`,
  maxWidth: '25rem',
  fontFamily: theme.daDirekt.fontFamily,
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.125rem',

  [theme.breakpoints.up('desktop')]: {
    maxWidth: '100%',
    fontSize: '1.875rem',
    lineHeight: '1.625rem',
  },
}));

export const StyledDaDirektCrossSellingCardText = styled('p')(({ theme }) => () => ({
  fontFamily: theme.daDirekt.fontFamily,
  maxWidth: '16.375rem',
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '1.25rem',

  [theme.breakpoints.up('desktop')]: {
    maxWidth: '21.25rem',
    fontSize: '1.25rem',
    lineHeight: '1.625rem',
  },
}));

export const StyledDaDirektCrossSellingCardButton = styled('button')(({ theme }) => () => ({
  all: 'unset',
  // padding: '0.75rem 2rem',
  padding: `${theme.spacing('MEDIUM')} ${theme.spacing('2XL')}`,
  width: '12.5rem',
  height: '3.125rem',
  fontFamily: theme.daDirekt.fontFamily,
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '100%',
  textAlign: 'center',
  color: PALETTE.WHITE,
  backgroundColor: theme.palette.main.professional_blue,
  borderRadius: 4,
  cursor: 'pointer',
  boxSizing: 'border-box',

  [theme.breakpoints.up('desktop')]: {
    paddingTop: theme.spacing('LARGE'),
    paddingBottom: theme.spacing('LARGE'),
    height: '3.625rem',
  },
}));

export const StyledDaDirektCrossSellingCardDaDirektLogo = styled('img')(({ theme }) => () => ({
  position: 'absolute',
  right: '1rem',
  bottom: '1.5rem',
  width: '4.25rem',
  height: 'auto',

  [theme.breakpoints.up('desktop')]: {
    width: '5.75rem',
    top: '1.5rem',
    right: '1.5rem',
  },
}));

export const StyledDaDirektCrossSellingImageWrapper = styled('div')(({ theme }) => ({
  display: 'none',
  position: 'absolute',
  right: 0,
  bottom: 0,

  [theme.breakpoints.up('desktop')]: {
    display: 'block',
  },
}));

export const StyledDaDirektDentalCrossSellingImageWrapper = styled(
  StyledDaDirektCrossSellingImageWrapper
)`
  > img {
    width: 11.875rem;
    height: auto;
  }
`;
export const StyledDaDirektPetCrossSellingImageWrapper = styled(
  StyledDaDirektCrossSellingImageWrapper
)`
  > img {
    width: 13.75rem;
    height: auto;
  }
`;

export const StyledDaDirektHealthCrossSellingImageWrapper = styled(
  StyledDaDirektCrossSellingImageWrapper
)`
  > img {
    width: 12rem;
    height: auto;
  }
`;
